<section class="hobCard" aria-label="getting started">
    <div class="hobBlobs" aria-hidden="true">
        <span class="hobBlob hobBlob1"></span>
        <span class="hobBlob hobBlob2"></span>
    </div>

    <header class="hobHead">
        <div class="hobHeadText">
            <span class="hobEyebrow">{{ 'ai.home_onb_eyebrow' | transloco }}</span>
            <h2 class="hobTitle">
                {{ 'ai.home_onb_title' | transloco }}
                <span class="hobCountChip">
                    <span class="hobCountVal">{{ completedCount }}</span>
                    <span class="hobCountSep">/</span>
                    <span class="hobCountMax">{{ totalSteps }}</span>
                </span>
            </h2>
        </div>
    </header>

        <div class="hobProgressTrack" [attr.aria-valuenow]="progressPct" aria-valuemin="0" aria-valuemax="100" role="progressbar">
            <span class="hobProgressFill" [style.width.%]="progressPct"></span>
        </div>

        <div class="hobSteps">
            <button type="button"
                    class="hobStep"
                    [class.hobStepDone]="hasScene"
                    [class.hobStepActive]="!hasScene"
                    (click)="onStepScene()">
                <span class="hobStepBadge">
                    <span class="hobStepNum">1</span>
                </span>
                <span class="hobStepBody">
                    <span class="hobStepHead">
                        <mat-icon class="hobStepIcon">auto_awesome</mat-icon>
                        <span class="hobStepTitle">{{ 'ai.home_onb_step1_title' | transloco }}</span>
                    </span>
                    <span class="hobStepDesc">{{ 'ai.home_onb_step1_desc' | transloco }}</span>
                </span>
                <mat-icon class="hobStepGo">arrow_forward</mat-icon>
            </button>

            <button type="button"
                    class="hobStep"
                    [class.hobStepDone]="hasDownload"
                    [class.hobStepActive]="hasScene && !hasDownload"
                    [class.hobStepLocked]="!hasScene"
                    (click)="onStepDownload()">
                <span class="hobStepBadge">
                    <span class="hobStepNum">2</span>
                </span>
                <span class="hobStepBody">
                    <span class="hobStepHead">
                        <mat-icon class="hobStepIcon">cloud_download</mat-icon>
                        <span class="hobStepTitle">{{ 'ai.home_onb_step2_title' | transloco }}</span>
                    </span>
                    <span class="hobStepDesc">{{ 'ai.home_onb_step2_desc' | transloco }}</span>
                </span>
                <mat-icon class="hobStepGo">arrow_forward</mat-icon>
            </button>

            <button type="button"
                    class="hobStep"
                    [class.hobStepDone]="hasPlayer"
                    [class.hobStepActive]="hasDownload && !hasPlayer"
                    [class.hobStepLocked]="!hasDownload"
                    (click)="onStepPlayer()">
                <span class="hobStepBadge">
                    <span class="hobStepNum">3</span>
                </span>
                <span class="hobStepBody">
                    <span class="hobStepHead">
                        <mat-icon class="hobStepIcon">cast</mat-icon>
                        <span class="hobStepTitle">{{ 'ai.home_onb_step3_title' | transloco }}</span>
                    </span>
                    <span class="hobStepDesc">{{ 'ai.home_onb_step3_desc' | transloco }}</span>
                </span>
                <mat-icon class="hobStepGo">arrow_forward</mat-icon>
            </button>

            <button type="button"
                    class="hobStep"
                    [class.hobStepDone]="hasOnline"
                    [class.hobStepActive]="hasPlayer && !hasOnline"
                    [class.hobStepLocked]="!hasPlayer"
                    (click)="onStepOnline()">
                <span class="hobStepBadge">
                    <span class="hobStepNum">4</span>
                </span>
                <span class="hobStepBody">
                    <span class="hobStepHead">
                        <mat-icon class="hobStepIcon">live_tv</mat-icon>
                        <span class="hobStepTitle">{{ 'ai.home_onb_step4_title' | transloco }}</span>
                    </span>
                    <span class="hobStepDesc">{{ 'ai.home_onb_step4_desc' | transloco }}</span>
                </span>
                <mat-icon class="hobStepGo">arrow_forward</mat-icon>
            </button>
        </div>
</section>
